"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientActions = void 0;
const FetchActions_1 = require("../lib/FetchActions");
class ClientActions extends FetchActions_1.FetchActions {
    constructor() {
        super(...arguments);
        this.post = async (body) => {
            const path = this.leadType === "debt" ? "/leads/debt" : "/leads";
            return await this.execute(path, body);
        };
        this.update = async (leadId, body, updateOptions = {}) => {
            return await this.execute(`/leads/update/${leadId}`, body, {
                queryParams: updateOptions,
            });
        };
        this.review = (leadId, status, reviewOptions) => {
            return this.execute(`/leads/review/${leadId}`, {}, {
                queryParams: {
                    status,
                    ...reviewOptions,
                },
            });
        };
    }
}
exports.ClientActions = ClientActions;
//# sourceMappingURL=ClientActions.js.map